import { memo, useState, useEffect, useRef } from 'react';
// import { isIOS } from 'react-device-detect';

import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import VeVideo from '@wconcept/wconcept-ui-renewal/components/atoms/VeVideo';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import { IPlayAuthTokenConfig } from '@byteplus/veplayer';
import useInView from '@wconcept/wconcept-ui-renewal/hooks/useInView';

import * as S from './style';

interface IProps {
  videoSrc?: string;
  videoPoster?: string;
  imgSrc?: string;
  rs?: string;
  vid?: string;
  token?: IPlayAuthTokenConfig;
  definitionType?: '480p' | '720p' | '1080p';
  getNewToken?: () => Promise<IPlayAuthTokenConfig>;
  title?: string;
  subTitle?: string;
  priority?: boolean;
  sizeType?: 'default' | 'small';
}

const MainVisualBanner = ({
  videoSrc,
  videoPoster,
  imgSrc,
  rs,
  vid,
  token,
  getNewToken,
  title,
  subTitle,
  priority,
  definitionType,
  sizeType = 'default',
}: IProps) => {
  const [videoEl, setVideoEl] = useState<any>(null);
  const [ref, isVisible] = useInView({
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  });

  const isActive = isVisible;

  const videoElRef = useRef(videoEl);
  const isActiveRef = useRef(isActive);

  useEffect(() => {
    videoElRef.current = videoEl;
    isActiveRef.current = isActive;
  }, [videoEl, isActive]);

  // iOS 백그라운드/포그라운드 전환 감지
  // useEffect(() => {
  //   if (!isIOS) return;

  //   const handleVisibilityChange = () => {
  //     const isHidden = document.hidden;

  //     if (!isHidden && videoElRef.current?.player && isActiveRef.current) {
  //       setTimeout(() => {
  //         videoElRef.current?.player?.pause();
  //       }, 300);
  //     }
  //   };

  //   document.addEventListener('visibilitychange', handleVisibilityChange);

  //   // eslint-disable-next-line consistent-return
  //   return () => {
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //   };
  // }, []);

  // 화면 내 가시성에 따른 비디오 제어 (useInView 활용)
  useEffect(() => {
    const videoElement = videoEl?.player;
    if (!videoElement) return;

    if (isActive) {
      videoElement.play().catch(() => {});
    } else {
      videoElement.pause();
    }
  }, [isActive, videoEl]);

  return (
    <S.MainVisualBanner
      className={title || subTitle ? 'has-text' : undefined}
      $sizeType={sizeType}
      ref={ref}
    >
      {vid || videoSrc ? (
        <div className="visual-wrap video-wrap">
          <VeVideo
            src={videoSrc}
            poster={videoPoster}
            vid={vid}
            token={token}
            muted
            loop
            clickControl
            autoplay={false}
            getNewToken={getNewToken}
            priority={priority}
            definitionType={definitionType}
            handleComplete={el => {
              if (el?.player) {
                setVideoEl(el);
              }
            }}
          />
          <Img
            src={getResizeImageUrl(videoPoster, rs)}
            priority={priority}
            className="video-poster"
          />
        </div>
      ) : (
        <div className="visual-wrap img-wrap">
          <Img src={getResizeImageUrl(imgSrc, rs)} priority={priority} />
        </div>
      )}
      {(title || subTitle) && (
        <div className="text-wrap">
          {title && (
            <Text
              className="title"
              color="#fff"
              weight={600}
              size={32}
              lineHeight={40}
              block
            >
              {title}
            </Text>
          )}
          {subTitle && (
            <Text
              className="sub-title"
              color="#fff"
              weight={500}
              size={14}
              lineHeight={20}
              block
            >
              {subTitle}
            </Text>
          )}
        </div>
      )}
    </S.MainVisualBanner>
  );
};
export default memo(MainVisualBanner);
